
<v-select
    :items     = "items"
    item-value = "id"
    item-text  = "name"
    :label     = "label"
    v-model    = "selected"
    @change    = "onChange"
    :rules     = "rules"
    :readonly  = "readonly"
    :disabled  = "readonly"
    :clearable = "clearable"
/>
